import { ApiProperty } from '@nestjs/swagger';
import { IsEnum, ValidationArguments, ValidationOptions, registerDecorator } from 'class-validator';
import { Transform, TransformFnParams, Type } from 'class-transformer';
import { ClientContactType } from '../clientContactType';
import { validatorMessageFromDictionary } from '../../../utils/validation/i18n/createMessagesDictionary';
import { LanguageCode } from '../../resource/language';
import { PHONE_NUMBER_TEST_REGEXP } from '../../../const/regexp';
import { clientContactTypesWithPhoneNumbers } from '../../../const/client/contact';
import { phoneNumberTransformer } from '../../../utils/transformer/phoneNumber';

const contactValueTransformer = (params: TransformFnParams) => {
  const obj = params.obj as { type: ClientContactType; value: unknown };

  if (!('type' in obj)) {
    return params.value;
  }

  if (!clientContactTypesWithPhoneNumbers.includes(Number(obj.type))) {
    return params.value;
  }

  return phoneNumberTransformer(params);
};

const MAX_LENGTH = 255;

const IsContactValue = (validationOptions?: ValidationOptions) => {
  return (object: Object, propertyName: string) => {
    registerDecorator({
      name: 'isContactValue',
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown, args: ValidationArguments) {
          const obj = args.object as { type: ClientContactType; value: unknown };

          if (!('type' in obj)) {
            return false;
          }

          if (typeof value !== 'string' || value.length < 1 || value.length > MAX_LENGTH) {
            return false;
          }

          if (!clientContactTypesWithPhoneNumbers.includes(Number(obj.type))) {
            return true;
          }

          return PHONE_NUMBER_TEST_REGEXP.test(value);
        },
      },
    });
  };
};

export class ClientContactUpdateRequest {
  @ApiProperty({ enum: ClientContactType })
  @Type(() => Number)
  @IsEnum(ClientContactType)
  type: ClientContactType;

  @ApiProperty()
  @Transform(contactValueTransformer)
  @IsContactValue({ message: validatorMessageFromDictionary({ [LanguageCode.Russian]: 'Некорректное значение' }) })
  value: string;
}
